import React, { useContext, useState } from 'react';
import { KatLink } from '@amzn/katal-react';
import { ReadMoreConstants } from 'src/constants/ProjectConstants';
import { TranslationContext } from 'src/state/providers/TranslationProvider';

interface IReadMore {
  text: string;
  maxlength?: number;
}
/**
 * Component responsible to render ...ReadMore if there the length of the text is more than maxLength
 * If we click on ReadMore then the entire text is shown with Readless.
 * If the text is less than maxLength. Readmore or Readless is not shown.
 * @param IReadMore
 * @returns ReadMore
 */
const ReadMore: React.FC<IReadMore> = ({ text, maxlength = 500 }) => {
  const { commonBundle } = useContext(TranslationContext);
  const [showAll, setShowAll] = useState<boolean>(false);
  if (!text) return null;
  if (showAll) {
    if (text.length > maxlength) {
      return (
        <>
          {text}
          <KatLink onClick={() => setShowAll(false)}>
            {commonBundle.getMessage(ReadMoreConstants.READ_LESS)}
          </KatLink>
        </>
      );
    }
    return <>{text}</>;
  }
  const textTruncated = text.substring(0, maxlength);
  if (text.length > maxlength) {
    return (
      <>
        {textTruncated}...
        <KatLink onClick={() => setShowAll(true)}>
          {commonBundle.getMessage(ReadMoreConstants.READ_MORE)}
        </KatLink>
      </>
    );
  }
  return <>{text}</>;
};

export { ReadMore };
